import { Modal, Text, SimpleGrid } from "@mantine/core";
import GoogleCalendarCard from "./GoogleCalendarCard";
import ZoomCard from "./ZoomCard";

const IntegrationsModal = ({ opened, setOpened }) => {
  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title={<Text fw={700} fz="xl">Integrations</Text>}
      centered
      size="lg"
      padding="xl"
      radius="md"
      overlayOpacity={0.55}
      overlayBlur={3}
    >
      <Text c="dimmed" size="sm" mb="xl">
        Connect your favorite tools to streamline your workflow.
      </Text>

      <SimpleGrid cols={1} spacing="lg">
        <GoogleCalendarCard />
        <ZoomCard />
      </SimpleGrid>
    </Modal>
  );
};

export default IntegrationsModal;
